import { render, staticRenderFns } from "./partnerDoctor.vue?vue&type=template&id=58d852a4&"
import script from "./partnerDoctor.vue?vue&type=script&lang=js&"
export * from "./partnerDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports